const CameraIcon = () => (
  <svg
    width="24px"
    height="20px"
    viewBox="0 0 24 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>ic_camera_placeholder</title>
    <desc>Created with Sketch.</desc>
    <g id="Symbols" stroke="none" strokeWidth="1">
      <g id="Placeholder_camera" transform="translate(-34.000000, -35.000000)">
        <path
          d="M54.7718686,38.8709677 C56.3158905,38.8709677 57.5675676,40.1226448 57.5675676,41.6666667 L57.5675676,51.7741935 C57.5675676,53.3182154 56.3158905,54.5698925 54.7718686,54.5698925 L36.7956989,54.5698925 C35.251677,54.5698925 34,53.3182154 34,51.7741935 L34,41.6666667 C34,40.1226448 35.251677,38.8709677 36.7956989,38.8709677 L54.7718686,38.8709677 Z M45.7837838,41.4874552 C42.8913375,41.4874552 40.5465465,43.8303379 40.5465465,46.7204301 C40.5465465,49.6105223 42.8913375,51.953405 45.7837838,51.953405 C48.67623,51.953405 51.021021,49.6105223 51.021021,46.7204301 C51.021021,43.8303379 48.67623,41.4874552 45.7837838,41.4874552 Z M45.8918919,44.2473118 C47.3248469,44.2473118 48.4864865,45.402706 48.4864865,46.827957 C48.4864865,48.253208 47.3248469,49.4086022 45.8918919,49.4086022 C44.4589369,49.4086022 43.2972973,48.253208 43.2972973,46.827957 C43.2972973,45.402706 44.4589369,44.2473118 45.8918919,44.2473118 Z M49.1386225,35 C49.4949352,35 49.7837838,35.2888485 49.7837838,35.6451613 L49.7837838,36.9354839 C49.7837838,37.2917966 49.4949352,37.5806452 49.1386225,37.5806452 L42.6451613,37.5806452 C42.2888485,37.5806452 42,37.2917966 42,36.9354839 L42,35.6451613 C42,35.2888485 42.2888485,35 42.6451613,35 L49.1386225,35 Z"
          id="ic_camera_placeholder"
          fill="#FFFFFF"
        ></path>
      </g>
    </g>
  </svg>
)

export default CameraIcon
